import { useOrdersStore } from '../store';

export const useCartQuantity = (productId: string): number =>
  useOrdersStore(
    (s) => s.orders
      .filter((o) => o.productId === productId)
      .reduce((acc, item) => acc + item.quantity, 0)
  );
